import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Content row p-3 d-flex flex-column justify-content-center", `${_ctx.data['Sección'] === 'Portada' ? 'cover' : 'text'}`]),
    id: `${_ctx.data['Clave']}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "content",
        innerHTML: _ctx.data['Contenido']
      }, null, 8, _hoisted_3)
    ])
  ], 10, _hoisted_1))
}